export default "__VITE_ASSET__CC3gAE6R__"